import {
  SidePanel,
  SidePanelContent,
  SidePanelHeader,
  SidePanelBody,
  SidePanelFooter,
} from "@/components/ui/SidePanel";
import { cn } from "@/components/ui/cn";
import { PostFormContent } from "./CreatePostForm";
import type { Post } from "@/api/clubsApi";

interface EditPostSidePanelProps {
  post: Post | null;
  clubId: string;
  authorId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function EditPostSidePanel({
  post,
  clubId,
  authorId,
  open,
  onOpenChange,
}: EditPostSidePanelProps) {
  if (!post) return null;

  return (
    <PostFormContent
      clubId={clubId}
      authorId={authorId}
      editingPost={post}
      onClose={() => onOpenChange(false)}
      onSuccess={() => onOpenChange(false)}
    >
      {(formContent, footerProps) => (
        <SidePanel open={open} onOpenChange={(newOpen) => {
          if (!newOpen && !footerProps.isSubmitting) {
            footerProps.onCancel();
          }
        }}>
          <SidePanelContent>
            <SidePanelHeader title="Edit Post" onClose={() => {
              if (!footerProps.isSubmitting) {
                footerProps.onCancel();
              }
            }} />

            <SidePanelBody className="pt-0">
              <div className="p-5 space-y-4">
                {formContent}
              </div>
            </SidePanelBody>

            <SidePanelFooter>
              <div className="flex gap-3 justify-end">
                <button
                  type="button"
                  onClick={footerProps.onCancel}
                  disabled={footerProps.isSubmitting}
                  className="px-4 py-3 rounded-full text-body-2-medium text-text-secondary hover:bg-surface-2 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={footerProps.onSubmit}
                  disabled={!footerProps.canSubmit}
                  className={cn(
                    "flex items-center justify-center gap-2 px-4 py-3 rounded-full text-body-2-medium transition-opacity",
                    footerProps.canSubmit
                      ? "bg-olive text-white hover:opacity-90"
                      : "bg-olive/50 text-white/70 cursor-not-allowed"
                  )}
                >
                  {footerProps.submitLabel}
                </button>
              </div>
            </SidePanelFooter>
          </SidePanelContent>
        </SidePanel>
      )}
    </PostFormContent>
  );
}
